/**
 * Mirrors CategoryIconHelper::resolveSymbol()'s fallback chain (PHP) so any CSR
 * no-image placeholder resolves to the same sprite symbol as the SSR
 * <x-no-image-placeholder> one. DOM-free on purpose — callers inject the
 * existence check via a FormBase-backed getter (see the project's rule that
 * DOM querying only happens inside FormBase subclasses).
 */

export const CATEGORY_ALL_SYMBOL = "vlf-cat-all";

export function resolveCategorySymbol(
    categoryId: number | string | null | undefined,
    isKnownSymbol: (symbol: string) => boolean,
): string {
    if (categoryId !== null && categoryId !== undefined && String(categoryId).toLowerCase() === "all") {
        return CATEGORY_ALL_SYMBOL;
    }

    if (categoryId !== null && categoryId !== undefined && /^\d+$/.test(String(categoryId))) {
        const derived = `vlf-cat-${categoryId}`;
        if (isKnownSymbol(derived)) return derived;
    }

    return CATEGORY_ALL_SYMBOL;
}

export function buildCategoryPlaceholderHtml(symbol: string): string {
    return (
        '<div class="no-image-placeholder" aria-hidden="true">' +
        `<svg class="vlf-icon category-icon vlf-icon--48 no-image-placeholder__icon" aria-hidden="true" focusable="false"><use href="#${symbol}"></use></svg>` +
        "</div>"
    );
}

/** Mirrors <x-category-icon :size="24"> — the inline leading icon used on a meta/category line. */
export function buildCategoryIconHtml(symbol: string, size = 24): string {
    return `<svg class="vlf-icon category-icon vlf-icon--${size}" aria-hidden="true" focusable="false"><use href="#${symbol}"></use></svg>`;
}
